<template>
    <v-container>
        <v-card color="primary" dark>
            <v-card-title>
                    <span style="font-weight: bold">
                        จำนวนที่ครอง 30 % แต่ล่ะตำแหน่ง
                    </span>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="ค้นหา"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
        </v-card>
        <v-card color="#546E7A" dark>
            <v-card-text>
                <v-list-item>
                    <v-row class="d-flex justify-center">
                        <v-col
                                cols="12"
                                md="10">
                            <v-data-table
                                    :headers="headerData"
                                    :items="ReportData"
                                    :items-per-page="50"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :search="search"
                                    class="elevation-1"
                            >
                                <template v-slot:item.count1="{item}">
                                    <div v-if="item.count1 > 0 " style="cursor: pointer" @click="ShowDetail(item, '5', false)">
                                        <span>
                                            {{item.count1}} / {{item.StaffData.length}} คน
                                        </span>
                                        <span style="font-weight: bold;color: #B2FF59;margin-left: 5px">{{item.percent1}} %</span>
                                    </div>
                                    <span v-else>
                                            -
                                        </span>
                                </template>
                                <template v-slot:item.count2="{item}" >
                                    <div v-if="item.count2 > 0 " style="cursor: pointer" @click="ShowDetail(item, '6', false)">
                                        <span>
                                            {{item.count2}} / {{item.StaffData.length}} คน
                                        </span>
                                        <span style="font-weight: bold;color: #B2FF59;margin-left: 5px">{{item.percent2}} %</span>
                                    </div>
                                    <span v-else>
                                            -
                                        </span>
                                </template>
                                <template v-slot:item.count3="{item}">
                                    <div v-if="item.count3 > 0 " style="cursor: pointer" @click="ShowDetail(item, '10', false)">
                                        <span>
                                            {{item.count3}} / {{item.StaffData.length}} คน
                                        </span>
                                        <span style="font-weight: bold;color: #B2FF59;margin-left: 5px">{{item.percent3}} %</span>
                                    </div>
                                    <span v-else>
                                            -
                                        </span>
                                </template>
                                <template v-slot:item.count4="{item}">
                                    <div v-if="item.count4 > 0 " style="cursor: pointer" @click="ShowDetail(item, '8', false)">
                                        <span>
                                            {{item.count4}} / {{item.StaffData.length}} คน
                                        </span>
                                        <span style="font-weight: bold;color: #B2FF59;margin-left: 5px">{{item.percent4}} %</span>
                                    </div>
                                    <span v-else>
                                            -
                                        </span>
                                </template>
                                <template v-slot:item.count5="{item}">
                                    <div v-if="item.count5 > 0 " style="cursor: pointer" @click="ShowDetail(item, '9', false)">
                                        <span>
                                            {{item.count5}} / {{item.StaffData.length}} คน
                                        </span>
                                        <span style="font-weight: bold;color: #B2FF59;margin-left: 5px">{{item.percent5}} %</span>
                                    </div>
                                    <span v-else>
                                            -
                                        </span>
                                </template>
                                <template v-slot:item.action="{item}">
                                       <v-btn outlined color="#00BCD4" @click="ShowDetail(item, '', true)">
                                           แสดงข้อมูลทั้งหมด
                                       </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-card-text>
        </v-card>
        <template>
            <v-dialog
                    v-model="dialog"
                    max-width="1000"
            >
                <v-card  color="#546E7A" dark>
                    <v-card-title class="headline">
                        แสดงข้อมูลบุคลากร ตำแหน่ง : {{PosName}}
                    </v-card-title>

                    <v-card-text>
                        <v-data-table
                                :headers="headerData2"
                                :items="DataToShow"
                                :items-per-page="5"
                                class="elevation-1"
                        >
                            <template v-slot:item.full_Name="{item}">
                                <span>
                                     {{item.full_Name}} ({{item.perid}})
                                </span>
                            </template>
                            <template v-slot:item.LevelName="{item}">
                                  <span v-if="item.LevelCode == '5' || item.LevelCode == '6' || item.LevelCode == '10'" style="font-weight: bold;color: cornflowerblue">
                                            {{item.LevelName}}
                                        </span>
                                <span v-else-if="item.LevelCode == '8' || item.LevelCode == '9'" style="font-weight: bold;color: cadetblue">
                                            {{item.LevelName}}
                                        </span>
                                <span v-else>
                                     {{item.LevelName}}
                                </span>
                            </template>
                        </v-data-table>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >
                            ปิดหน้าต่าง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Report30per",
        data() {
            return {
                sortBy: 'percent',
                sortDesc: true,
                search: '',
                dialog: false,
                isMobile: false,
                ReportData: [],
                DataToShow: {},
                PosName: '',
                headerData: [
                    {text: 'ตำแหน่ง', value: 'PosName'},
                    {text: 'ชำนาญการ', value: 'count1'},
                    {text: 'ชำนาญการพิเศษ', value: 'count2'},
                    {text: 'เชี่ยวชาญ', value: 'count3'},
                    {text: 'ชำนาญงาน', value: 'count4'},
                    {text: 'ชำนาญงานพิเศษ', value: 'count5'},
                    {text: '', value: 'action'},
                ],
                headerData2: [
                    {text: 'ชื่อ-สกุล', value: 'full_Name'},
                    {text: 'หน่วยงาน', value: 'dep_name'},
                    {text: 'ตำแหน่ง', value: 'pos_name'},
                    {text: 'ระดับ', value: 'LevelName'},
                ],
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, {passive: true})
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
                levelData: 'Level/getLevel',
                DepartData: 'Depart/getDepart',
                PositionsData: 'Positions/getPosition',
                staffData: 'Staff/getStaff',
            })
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
                initlevelData: 'Level/initLevelData',
                initDepartData: 'Depart/initDepartData',
                initPositionData: 'Positions/initPositionData',
                initStaffData: 'Staff/initStaffData',
            }),
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            goToPage: function (page) {
                this.$router.push(page)
            },
            ShowDetail(item, lv, cordi) {
                if (!cordi) {
                    this.dialog = true
                    this.DataToShow = {}
                    this.PosName = ''
                    this.PosName = item.PosName
                    this.DataToShow = item.StaffData.filter(item => item.lv_id == lv)
                } else {
                    this.dialog = true
                    this.DataToShow = {}
                    this.PosName = ''
                    this.PosName = item.PosName
                    this.DataToShow = item.StaffData
                }
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, {passive: true})
            this.initlevelData()
            this.initPositionData()
            this.initStaffData().then(res => {
                if (res) {
                    this.PositionsData.map(posi_i => {
                        var count1 = 0
                        var count2 = 0
                        var count3 = 0
                        var count4 = 0
                        var count5 = 0
                        this.staffData.map(staff_i => {
                            if (posi_i.PosCode == staff_i.pos_id) {
                                this.levelData.map(level_i => {
                                    if (staff_i.lv_id == level_i.LevelCode) {
                                        if (staff_i.lv_id == '5') {
                                            count1++
                                        } else if(staff_i.lv_id == '6') {
                                            count2++
                                        } else if(staff_i.lv_id == '10') {
                                            count3++
                                        } else if (staff_i.lv_id == '8') {
                                            count4++
                                        } else if (staff_i.lv_id == '9') {
                                            count5++
                                        }
                                        if (this.ReportData.length == 0) {
                                            this.ReportData.push({
                                                ...posi_i,
                                                percent1: 0,
                                                percent2: 0,
                                                percent3: 0,
                                                percent4: 0,
                                                percent5: 0,
                                                count1: count1,
                                                count2: count2,
                                                count3: count3,
                                                count4: count4,
                                                count5: count5,
                                                StaffData: [{
                                                    ...staff_i,
                                                    ...level_i
                                                }]
                                            })
                                        } else {
                                            var CheckCordi = false
                                            this.ReportData.map((report_i, idx) => {
                                                if (report_i.PosCode == posi_i.PosCode) {
                                                    CheckCordi = true
                                                    this.ReportData[idx].count1 = count1
                                                    this.ReportData[idx].count2 = count2
                                                    this.ReportData[idx].count3 = count3
                                                    this.ReportData[idx].count4 = count4
                                                    this.ReportData[idx].count5 = count5
                                                    this.ReportData[idx].StaffData.push({
                                                        ...staff_i,
                                                        ...level_i
                                                    })
                                                } else {
                                                    if (!CheckCordi && idx == this.ReportData.length - 1) {
                                                        this.ReportData.push({
                                                            ...posi_i,
                                                            percent1: 0,
                                                            percent2: 0,
                                                            percent3: 0,
                                                            percent4: 0,
                                                            percent5: 0,
                                                            count1: count1,
                                                            count2: count2,
                                                            count3: count3,
                                                            count4: count4,
                                                            count5: count5,
                                                            StaffData: [{
                                                                ...staff_i,
                                                                ...level_i
                                                            }]
                                                        })
                                                    }
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    })
                    this.ReportData.map(Report_i => {
                        Report_i.percent1 = parseFloat((100 / Report_i.StaffData.length) * Report_i.count1).toFixed(2)
                        Report_i.percent2 = parseFloat((100 / Report_i.StaffData.length) * Report_i.count2).toFixed(2)
                        Report_i.percent3 = parseFloat((100 / Report_i.StaffData.length) * Report_i.count3).toFixed(2)
                        Report_i.percent4 = parseFloat((100 / Report_i.StaffData.length) * Report_i.count4).toFixed(2)
                        Report_i.percent5 = parseFloat((100 / Report_i.StaffData.length) * Report_i.count5).toFixed(2)
                    })
                }
            })
        }

    }
</script>

<style scoped>

</style>